<template>
    <div>
    <v-select label="name" :filterable="false" :options="options" @search="onSearch" @input="setSelected" :value="selectedValue">

        <template slot="no-options">
        Type to search..
        </template>
        <template slot="option" slot-scope="option">
            <div class="d-center">
                 {{ option[field] }}
            </div>
        </template>
    </v-select>
    </div>
</template>

<script>
import CMDBService from '@/api-services/cmdb.service'
// import axios from 'axios'  
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: "AutoCompleteSelect",
  components:{
    vSelect
  },
  props: {
      field:String,
      selectedValue:String
  },
  data () {
      return {
        options: [],
        originalValueSelected:'',
      }
  },
  created(){
      this.originalValueSelected=this.selectedValue
  },
  methods: {
    setSelected(value){
        if (value===null){  
            this.selectedValue = this.originalValueSelected
        } else {
            this.selectedValue = value[this.field] 
        }
        this.$emit('selected', this.selectedValue)
    },
    onSearch(search, loading) {
        if ((search!='') &&  (search.length>1)){
            this.search(loading, search, this.field, this)
        }
    },
    search: _.debounce((loading, searchTerm, field, vm) => {
        loading(true)    
        let promise = CMDBService.getAllowedOptions(field, searchTerm)
        return promise.then((data) => {
            console.log(data)
            if (data.items.length>0){
                vm.options=data.items
            } else {
                vm.options=[]
            }
            loading(false)
        }).catch(error => {
            alert("Internal System Error: " + error.response.data.error)
            loading(false)
        })        
    }, 500) // Maximum run of once per 500 milliseconds
  }
}

</script>

